import React from "react";
import { useInView } from "react-intersection-observer";
import project1 from "../images/project1.png";
import project2 from "../images/project2.PNG";
import project3 from "../images/project3.PNG";
import project4 from "../images/project4.PNG";
import project5 from "../images/project5.PNG";
import project6 from "../images/project6.PNG";
import project7 from "../images/project7.PNG";
import project8 from "../images/project8.PNG";
import project9 from "../images/project9.PNG";
import project10 from "../images/project10.png";
import project11 from "../images/project-11.png";
import project12 from "../images/project-12.png";

const Projects = () => {
  // Intersection observer
  const { ref: projectSectionTitleRef, inView: projectSectionTitleIsVisible } =
    useInView({
      triggerOnce: true,
    });

  const { ref: projectOneRef, inView: projectOneIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectTwoRef, inView: projectTwoIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectThreeRef, inView: projectThreeIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectFourRef, inView: projectFourIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectFiveRef, inView: projectFiveIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectSixRef, inView: projectSixIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectSevenRef, inView: projectSevenIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectEightRef, inView: projectEightIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectNineRef, inView: projectNineIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectTenRef, inView: projectTenIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectElevenRef, inView: projectElevenIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: projectTwelveRef, inView: projectTwelveIsVisible } = useInView({
    triggerOnce: true,
  });

  return (
    <section className="project-section">
      <div className="project-section-title-intro-div" id="project-section">
        <div className="project-section-title-div">
          <h1
            ref={projectSectionTitleRef}
            className={`${
              projectSectionTitleIsVisible
                ? "project-section-title show-title"
                : "project-section-title"
            }`}
          >
            Projects
          </h1>
          <div className="title-underline"></div>
        </div>
        <div className="project-section-intro">
          <p>
            I Believe in practice based learning. And as a self-taught web
            developer, I get my hands busy building web applications. Below are
            some of my basic web projects that offer useful solutions and
            showcases my creative skills and logic.
          </p>
        </div>
      </div>

      <div className="projects-container">
        <div
          ref={projectOneRef}
          className={`${
            projectOneIsVisible ? "project-1 show-project-one" : "project-1"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project1} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                  <div className="project-tool">CSS3</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Food Ordering App</h3>
              <article className="about-project">
                <p>
                  A basic website that displays different food menu for
                  customers to choose and place order
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://food-menu-app.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/food-menu-app.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectTwoRef}
          className={`${
            projectTwoIsVisible ? "project-2 show-project-two" : "project-2"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project2} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Beach Resort website</h3>
              <article className="about-project">
                <p>
                  Deluxe Homes company website offers diffent types of room
                  services to people on vacation at the beach resort.
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://beach-resort-mauve.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/Beach-Resort.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectThreeRef}
          className={`${
            projectThreeIsVisible ? "project-3 show-project-three" : "project-3"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project3} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Color Generator App</h3>
              <article className="about-project">
                <p>
                  An App that helps users to create different shades of the same
                  color for their desktop and web projects
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://color-generator-liart.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/color-generator.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectFourRef}
          className={`${
            projectFourIsVisible ? "project-4 show-project-four" : "project-4"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project4} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Advice Generator App</h3>
              <article className="about-project">
                <p>
                  An application that uses API to generate random advice for
                  users when the dice button is clicked
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://advice-generator-app-neon-ten.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/advice-generator-app.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectFiveRef}
          className={`${
            projectFiveIsVisible ? "project-5 show-project-five" : "project-5"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project5} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Items to-do App</h3>
              <article className="about-project">
                <p>
                  An App that users can add items they want to get or things
                  they need to do to the list, cancel or delete and store items.
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://to-do-items.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/to-do-items.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectSixRef}
          className={`${
            projectSixIsVisible ? "project-6 show-project-six" : "project-6"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project6} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                  <div className="project-tool">APIs</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Countries website</h3>
              <article className="about-project">
                <p>
                  A website that shows all countries using APIs to get their
                  details such as population, capital, continent etc.
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://countries-api-with-color-theme-switcher.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/countries-api-with-color-theme-switcher.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectSevenRef}
          className={`${
            projectSevenIsVisible ? "project-7 show-project-seven" : "project-7"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project7} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Random Text Generator App</h3>
              <article className="about-project">
                <p>
                  An application for generating selected paragraphs of random
                  dummy text for users to use on any project
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://dummy-text-generator-rho.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/dummy-text-generator.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectEightRef}
          className={`${
            projectEightIsVisible ? "project-8 show-project-eight" : "project-8"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project8} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Space Tourism Website</h3>
              <article className="about-project">
                <p>
                  A website that describes all details about space and different
                  planets
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://space-tourism-website-two.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/space-tourism-website.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectNineRef}
          className={`${
            projectNineIsVisible ? "project-9 show-project-nine" : "project-9"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project9} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Frequently Asked Questions page</h3>
              <article className="about-project">
                <p>
                  A website that shows Frequently asked questions on a company
                  web page
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://faqs-blush.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/faqs.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectTenRef}
          className={`${
            projectTenIsVisible ? "project-10 show-project-ten" : "project-10"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project10} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Technical Documentation Page</h3>
              <article className="about-project">
                <p>
                  A technical documentation page that explains cascading style
                  sheet in details
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://esther-inyang.github.io/technical-documentation/#css_tables"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/technical-documentation.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectElevenRef}
          className={`${
            projectElevenIsVisible
              ? "project-11 show-project-eleven"
              : "project-11"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project11} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Natours Landing Page</h3>
              <article className="about-project">
                <p>
                  A company landing page that contains details about the
                  company, staff and signup form
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://esther-inyang.github.io/natours-project/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/Esther-Inyang/natours-project.git"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={projectTwelveRef}
          className={`${
            projectTwelveIsVisible
              ? "project-12 show-project-twelve"
              : "project-12"
          }`}
        >
          <div className="project-bg">
            <div className="project-image-div">
              <img src={project12} alt="" className="project-image" />
              <div className="project-tools-container">
                <h3>Built with</h3>
                <div className="project-tools-div">
                  <div className="project-tool">HTML</div>
                  <div className="project-tool">CSS3</div>
                  <div className="project-tool">JavaScript</div>
                  <div className="project-tool">React</div>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3 className="project-title">Portfolio page</h3>
              <article className="about-project">
                <p>
                  A portfolio website that contains details about my web design
                  projects
                </p>
              </article>
              <div className="see-project-links-div">
                <a
                  href="https://esther-inyang.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-website-link"
                >
                  visit website
                </a>
                <div className="links-divider"></div>
                <a
                  href="https://github.com/esther-inyang"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="see-codes-link"
                >
                  view codes
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
